// ABOUTME: Component for selecting a study family's analysis tools
// ABOUTME: Provides navigation to different visualization and analysis approaches
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { StudyFamily } from '../../interfaces/i-datasets';
import { ToolCard, navFor } from '../../study-families';

@Component({
  selector: 'app-tool-selection',
  templateUrl: './tool-selection.component.html',
  styleUrl: './tool-selection.component.scss',
})
export class ToolSelectionComponent {
  /** Bound from the route's `data.family` via bindToComponentInputs. */
  @Input() family: StudyFamily = 'gwas16';

  get tools(): ToolCard[] {
    return navFor(this.family).tools;
  }

  get label(): string {
    return navFor(this.family).label;
  }

  constructor(private router: Router) {}

  navigateTo(tool: ToolCard): void {
    if (!tool.comingSoon && tool.route !== '#') {
      this.router.navigate([tool.route]);
    }
  }

  goBack(): void {
    this.router.navigate(['/home']);
  }
}
